import React from 'react';
import PropTypes from 'prop-types';
import { PageReactDataTable, Paper } from '@metarouter-private/mr-mui';
import deliveryLogsColumns from './deliveryLogsColumns';
import DeliveryLogsExpandedRow from './DeliveryLogsExpandedRow';

const LOGS_PER_PAGE = 25;

export default function DeliveryLogsTable({ onFetchPage, data, pagination, loading }) {
  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <PageReactDataTable
        columns={deliveryLogsColumns}
        perPage={LOGS_PER_PAGE}
        onFetchPage={onFetchPage}
        data={data}
        pagination={pagination}
        loading={loading}
        expandableRows
        expandOnRowClicked
        expandableRowsComponent={DeliveryLogsExpandedRow}
      />
    </Paper>
  );
}

DeliveryLogsTable.propTypes = {
  onFetchPage: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  pagination: PropTypes.shape({
    count: PropTypes.number,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
};
